import type { Locale } from "@/entities/language";

import i18next from "i18next";

import { APP_DEFAULT_LOCALE, APP_LOCALES } from "./language.constant";

export const isAppLocale = (locale: string): locale is Locale => {
  return locale && APP_LOCALES.includes(locale as Locale) ? true : false;
};

/**
 * ⚠️ Always prefer using `useAppLocale()` when possible ⚠️
 */
export const getAppLocale = (): Locale => {
  return handleFallbackAppLocale(i18next.language);
};

export const handleFallbackAppLocale = (locale?: string): Locale => {
  if (locale && isAppLocale(locale)) return locale;

  // We should never get here as `i18next` should always
  // be inited with app settings. But let's be safe and
  // always handle fallback values.
  return getBrowserLocale() ?? APP_DEFAULT_LOCALE;
};

export const getBrowserLocale = (): Locale | undefined => {
  const locale = navigator.language.split("-")[0];
  return isAppLocale(locale) ? locale : undefined;
};
